import { render, staticRenderFns } from "./TeamDashboard.vue?vue&type=template&id=60c1cf08&scoped=true"
import script from "./TeamDashboard.vue?vue&type=script&lang=js"
export * from "./TeamDashboard.vue?vue&type=script&lang=js"
import style0 from "./TeamDashboard.vue?vue&type=style&index=0&id=60c1cf08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c1cf08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c1cf08')) {
      api.createRecord('60c1cf08', component.options)
    } else {
      api.reload('60c1cf08', component.options)
    }
    module.hot.accept("./TeamDashboard.vue?vue&type=template&id=60c1cf08&scoped=true", function () {
      api.rerender('60c1cf08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/TeamDashboard.vue"
export default component.exports